import type { TypedUseSelectorHook } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { agenciesReducer } from './agencies/agencies.slice';
import { alertReducer } from './alert/alert.slice';
import { authenticationReducer } from './authentication/authentication.slice';
import { divisionsReducer } from './divisions/divisions.slice';
import { formIsDirtyReducer } from './formIsDirty/formIsDirty.slice';
import { menuReducer } from './menu/menu.slice';
import { modalsReducer } from './modals/modals.slice';
import { peopleReducer } from './people/people.slice';
import { policiesReducer } from './policies/policies.slice';
import { prioritiesReducer } from './priorities/priorities.slice';
import { statisticsReducer } from './statistics/statistics.slice';
import { usersReducer } from './users/users.slice';
import { yearsReducer } from './years/years.slice';

export const store = configureStore({
  reducer: {
    alert: alertReducer,
    authentication: authenticationReducer,
    policies: policiesReducer,
    modals: modalsReducer,
    priorities: prioritiesReducer,
    menu: menuReducer,
    people: peopleReducer,
    agencies: agenciesReducer,
    divisions: divisionsReducer,
    statistics: statisticsReducer,
    formIsDirty: formIsDirtyReducer,
    years: yearsReducer,
    users: usersReducer,
  },
  devTools: true,
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
